// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-14T08:21:21+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192155
//    Project:        554
//    Environment:    5124 - master
//    MD5:            7977547ed57c360a8e3cd2ff299891cb
//    Signature:      eyJpdiI6IlBiSm40XC95MUVqbTRXRGZzeGtuanhBPT0iLCJ2YWx1ZSI6IkhOZitPY0dDOWMwdXJ6TlZUcXN3YllYdzUzbHFcL1FzczlRUEx3bklYSGFpcmdVU0pLTHBCXC93dmNHUW9US3NxNEpsTXpZSHFic2dDcFwvdWVQSkQ0RWZCXC9weU04cGZ6S0xhMlRBXC9xc2ZQV3VuSkxJY0JSc3NJbnBOMitRVFFReG1OVW01ZjhUTUdkeXN6czR6dkZ6UW1rWEtBRXVVNE1IY1FndWFmQzR3bXFQaXQrMWpuMThwSXJaOGUxQnNhQWRPN2FOWER5c0lJSHVtRHRYN3RSZ214Qk1vWHZVaHRKSThIaFZMR25EZU9GNUd6NHV3eUt5djJJbld2SlJ5SXNKZDN5c3JCOXJqbnFRT0RKeTd1U1BPNml4djdoQkZLQnNhTXIwMmlHV2pGWnZCblM2WDF6NTNCMGpWRHJGVmlqdkwwZDY2V0ZwdnR5OTdYMjhqRVkrb3QwazdNdUVQZW5Gdk1jMEFjdENcL2NaUjdHWVhpQkU0dzdQZ0RRcTZWbG9TUVFUdFZodzB3bkNtdVhLU0lLUDU4ZDJaMERZZmMyV3FqOGFMbnROZXFIT009IiwibWFjIjoiMDMxMTNmYzQ3MzRlNmNmNDY2ZmJlMzVjMjA4MjNlZTkxN2I5ODk5NzAzN2QyOGQzNGEzYzdjNDE4NjgzZDYzYiJ9
class ProductBuilder extends HTMLElement {
    constructor() {
        super(), document.addEventListener("shopify_xr_enabled", (t => {
            document.body.classList.add("supports-ar")
        }))
    }
    connectedCallback() {
        this.variantInput = this.querySelector("[data-variant-input]"), this.modelViewButton = this.querySelector("[data-view-model]"), this.productOptionPicker = this.querySelector("product-option-picker"), this.connect()
    }
    get product() {
        return this.hasAttribute("product") ? JSON.parse(this.getAttribute("product")) : null
    }
    async connect() {
        await this.init(), await this.render(), await this.addEventListeners(), await this.ready()
    }
    async init() {}
    async render() {}
    async ready() {
        const t = new Event("change");
        this.form = this.querySelector("form"), this.formData = serialize(this.form, {
            hash: !0
        }), await this.updateVariant(t), await this.configureAddOns(t), await this.updateAddOns(t), await this.updateSubmitButton(t), await this.updateTotal(t), this.singleVariant = this.form.querySelector(".js-single-variant"), this.singleVariant && setTimeout((() => {
            this.singleVariant.click()
        }), 1001)
    }
    async addEventListeners() {
        this.addEventListener("change", this.optionChanged.bind(this)), this.modelViewButton && this.modelViewButton.addEventListener("click", this.goToModel.bind(this))
    }
    goToModel(t) {
        if (!document.body.classList.contains("supports-ar")) {
            t.preventDefault();
            const e = document.querySelector("east-slider");
            if (e && e.swiper) {
                const t = e.querySelector("model-viewer"),
                    i = e.swiper;
                if (t) {
                    const e = t.closest(".swiper-slide");
                    if (e) {
                        const t = i.slides.indexOf(e); - 1 !== t && i.slideTo(t)
                    }
                }
            }
        }
    }
    async optionChanged(t) {
        if (t.target.closest("product-dropdown-option")) {
            const e = t.target.closest("product-dropdown-option").querySelector(".product_options__color-bubble");
            e && (e.className = "product_options__color-bubble product_options__color-bubble--" + t.target.value.toLowerCase().replace(/\s/g, ""))
        }
        this.form = t.target.closest("form"), this.formData = serialize(this.form, {
            hash: !0
        }), await this.updateVariant(t), await this.updateImage(t), await this.configureAddOns(t), await this.updateAddOns(t), await this.updateSubmitButton(t), await this.updateTotal(t)
    }
    async updateVariant(t) {
        if (this.formData.options) {
            const t = Object.values(this.formData.options);
            t.forEach(((t, e) => {
                const i = this.querySelector(`[data-ref="optionValue"][data-option="${e}"]`);
                i && (i.innerHTML = t)
            }));
            const e = JSON.stringify(t);
            this.variant = this.product.variants.find((t => JSON.stringify(t.options) === e)), this.variant && (this.variantInput.value = this.variant.id)
        }
    }
    async updateImage(t) {
        if (this.variant && this.variant.featured_media) {
            const t = document.querySelector("east-slider");
            if (t && t.swiper) {
                const e = t.querySelector(`[data-id="media--${this.variant.featured_media.id}"]`),
                    i = t.swiper;
                if (e) {
                    const t = i.slides.indexOf(e); - 1 !== t && i.slideTo(t)
                }
            }
        }
    }
    async configureAddOns(t) {
        if (!this.variant) return;
        this.querySelectorAll(".product-form__button-options[data-variant]").forEach((t => t.disabled = t.dataset.variant != this.variant.id))
    }
    async updateAddOns(t) {
        this.querySelectorAll('fieldset:not([disabled]) [data-ref="addOnQuantity"]').forEach((t => {
            const e = t.closest("fieldset"),
                i = e.querySelector('[data-ref="addOnValue"]'),
                a = e.querySelector("input[type=radio]:checked");
            a && i && (i.innerHTML = a.dataset.title)
        }))
    }
    async goToNextOption(t) {
        const e = t.closest(".product-form__button-options"),
            i = this.querySelectorAll(".product-form__button-options:not([disabled])");
        if (e && i.length > 1) {
            const t = Array.from(i).indexOf(e),
                a = (t + 1) % i.length;
            if (a !== t && a > t) {
                const t = i[a];
                t && (this.goingToNextOption = setTimeout((() => {
                    t.scrollIntoView({
                        behavior: "smooth"
                    })
                }), 200))
            }
        }
    }
    async updateSubmitButton(t) {
        this.querySelector('[data-ref="submitButton"]').disabled = !this.form.checkValidity()
    }
    async updateTotal(t) {
        const e = Number(this.querySelector('[data-ref="quantity"] input').value);
        if (this.form.checkValidity()) {
            let t = this.variant.price * e;
            this.querySelectorAll('fieldset:not([disabled]) [data-ref="addOnQuantity"]').forEach((e => {
                let i = e.closest("fieldset").querySelector("input[type=radio]:checked");
                if (i) t += Number(e.value) * Number(i.dataset.price);
                else {
                    const a = e.closest("fieldset").querySelector("select");
                    a && (i = a.options[a.selectedIndex], i && (t += Number(e.value) * Number(i.dataset.price)))
                }
            })), this.querySelectorAll('[data-ref="price"]:not(.frequently_price)').forEach((e => e.innerHTML = Shopify.formatMoney(t)))
        }
    }
}
customElements.define("product-builder", ProductBuilder);